/*--

  Handles the gift products logic.
  
  Louis-Charles Blais [info@22agencecreative.ca]
  
--*/


function addGift(giftId, quantity, bindTo) {
  const body = {
    items: [
      {
        id: giftId,
        quantity: quantity,
        properties: {
          'giftOf': bindTo
        }
      }
    ]
  }
  liquidAjaxCart.add(body);
}

let gifts = '';

function addCoffeeToGifts() {
  if (document.querySelector('#free-coffee-selector')) {
    let coffeeGift = document.querySelector('#free-coffee-selector').value;
    let grindSizeInput = document.querySelector('.free-coffee-content #small_grind_size_selector');
    if (grindSizeInput) {
      coffeeGift = coffeeGift + ':' + grindSizeInput.dataset.propertyName + '=' + grindSizeInput.value;
    }
    if (gifts != '') {
      gifts = gifts + ',' + coffeeGift;
    } else {
      gifts = coffeeGift;
    }
  }
}

function changeGifts() {
  gifts = '';
  for (let i = 0; i < giftsVariantsData.length; i++) {
    if (giftsVariantsData[i].id == document.querySelector('#selected-variant-id').value) {
      let gift = giftsVariantsData[i].gifts;
      let grindSizeInput = document.querySelector('.promo-bundle #small_grind_size_selector');
      if (grindSizeInput) {
        gift = gift + ':' + grindSizeInput.dataset.propertyName + '=' + grindSizeInput.value;
      }
      if (gifts != '') {
        gifts = gifts + ',' + gift;
      } else {
        gifts = gift;
      }
    }
  };
  addCoffeeToGifts();
  document.querySelector('#gifts-data').value = gifts;
}

changeGifts();


function checkForExtraGifts() {
  let cart_items = liquidAjaxCart.cart.items;
  let items_to_update = {
    updates: {}
  }
  let something_to_change = false;
  for (let i = 0; i < cart_items.length; i++) {
    if (cart_items[i].properties.giftOf) {
      let stillValid = false;
      let goodQuantity = false;
      let newQuantity = 0;
      
      // check if the parent product is still present and the quantity is good
      for (let x = 0; x < cart_items.length; x++) {
        if (cart_items[x].variant_id == cart_items[i].properties.giftOf) {
          stillValid = true;
          if (cart_items[x].quantity == cart_items[i].quantity) {
            goodQuantity = true;
          } else {
            newQuantity = cart_items[x].quantity;
          }
        }
      }

      // if it's not valid anymore, delete it
      if (!stillValid) {
        something_to_change = true;
        items_to_update.updates[cart_items[i].variant_id] = 0;
      } else {
        if (!goodQuantity) {
          something_to_change = true;
          items_to_update.updates[cart_items[i].variant_id] = newQuantity;
        }
      }    
    }
  }
  if (something_to_change) {
    liquidAjaxCart.update(items_to_update);
  }
}


// Fire the gift products logic every time the cart state is refreshed or updated
document.addEventListener("liquid-ajax-cart:request-end", function(event) {
  // checkForExtraGifts();
});


// Fire on load
// checkForExtraGifts();